import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);

export default {
    async downloadFile(context, { fileUrl, fileName }) {
        try {
            let response = await fetch(fileUrl);
            let blob = await response.blob();
            let urlObjet = window.URL.createObjectURL(blob);
            let lienTelechargement = document.createElement('a');
            lienTelechargement.href = urlObjet;
            lienTelechargement.download = fileName;
            document.body.appendChild(lienTelechargement);
            lienTelechargement.click();
            document.body.removeChild(lienTelechargement);

            // Révoquer l'URL objet pour libérer des ressources
            window.URL.revokeObjectURL(urlObjet);
        } catch (error) {
            console.error('Erreur lors du téléchargement du fichier :', error);
        }
    },
    initializeApplicationMode({ commit }) {
        const storedMode = localStorage.getItem('applicationMode');
        const mode = storedMode || 'simple';
        if (!storedMode) {
            localStorage.setItem('applicationMode', mode);
        }
        commit('SET_APPLICATION_MODE', mode);
    },
    updateApplicationMode({ commit }, mode) {
        localStorage.setItem('applicationMode', mode);
        commit('SET_APPLICATION_MODE', mode);
    },
};



// WEBPACK FOOTER //
// ./src/store/actions.js